import { render, staticRenderFns } from "./LandingContentMobile.vue?vue&type=template&id=0adbd8a2&scoped=true&"
import script from "./LandingContentMobile.vue?vue&type=script&lang=js&"
export * from "./LandingContentMobile.vue?vue&type=script&lang=js&"
import style0 from "./LandingContentMobile.vue?vue&type=style&index=0&id=0adbd8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adbd8a2",
  null
  
)

export default component.exports